// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Thorchain Unchained API
 * Provides access to thorchain chain data.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EstimateGasRequest
 */
export interface EstimateGasRequest {
    /**
     * Raw transaction
     * @type {string}
     * @memberof EstimateGasRequest
     */
    rawTx: string;
}

/**
 * Check if a given object implements the EstimateGasRequest interface.
 */
export function instanceOfEstimateGasRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "rawTx" in value;

    return isInstance;
}

export function EstimateGasRequestFromJSON(json: any): EstimateGasRequest {
    return EstimateGasRequestFromJSONTyped(json, false);
}

export function EstimateGasRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): EstimateGasRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'rawTx': json['rawTx'],
    };
}

export function EstimateGasRequestToJSON(value?: EstimateGasRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'rawTx': value.rawTx,
    };
}

